import React, { useMemo } from 'react'
import { Provider } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { useRewardsSheetContext } from '../../context/RewardsSheetProvider'
import { RewardsActionIds } from '../../types'
import { RewardsDeposit } from './RewardsDeposit'
import { RewardsWithdraw } from './RewardsWithdraw'

interface RewardsSheetProps {
  isSheetOpen: boolean
}

export const RewardsSheet = ({ isSheetOpen }: RewardsSheetProps) => {
  const { rewardsSheetAction } = useRewardsSheetContext()

  const { onBack, onClose, header, subHeader } = rewardsSheetAction || {}

  const sheetContent = useMemo(() => {
    switch (rewardsSheetAction?.actionId) {
      case RewardsActionIds.WITHDRAW:
        return <RewardsWithdraw withdrawType="standard" />
      case RewardsActionIds.DEPOSIT:
        return <RewardsDeposit />
      case RewardsActionIds.REMOVE_ALLOCATION:
        return <RewardsWithdraw withdrawType="removeAllocation" />
      default:
        return null
    }
  }, [rewardsSheetAction])

  const handleSheetClose = () => {
    onClose?.()
  }

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={handleSheetClose}
      subHeader={subHeader}
    >
      <Provider>{sheetContent}</Provider>
    </Sheet>
  )
}
